/** A bare site URL (`https://shop.example`) crawls its `/sitemap.xml`; an explicit `.xml` is kept. */
export function toSitemapUrl(raw: string): string {
  const trimmed = raw.trim();
  try {
    const u = new URL(trimmed);
    if (/\.xml(\.gz)?$/i.test(u.pathname)) return u.toString();
    return `${u.origin}/sitemap.xml`;
  } catch {
    return trimmed;
  }
}
